import { AfterContentInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { BehaviorSubject } from 'rxjs';
import { User } from '../../../models/user';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MsalService } from '@azure/msal-angular';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';
import { VjHelpNavBarComponent } from '../vj-help-nav-bar/vj-help-nav-bar.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
@Component({
  selector: 'app-vj-header',
  templateUrl: './vj-header.component.html',
  styleUrls: ['./vj-header.component.css']
})
export class VjHeaderComponent implements OnInit {

  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;
  public UserData: any;
  public UserStatus: boolean;
  private userSubject: BehaviorSubject<User>;
  profile:any;
  loadingStatus: boolean = false;

  constructor(
    public router: Router,
    private authenticationService: AuthenticationService, 
    public spinnerService: PageLoadingService,
    private modalService: NzModalService,
    private notification: NzNotificationService,
  ) {}

  ngOnInit(): void {
    this.getLoginStatus();
    this.spinnerService.visibility.subscribe({
      next(status) {
        this.loadingStatus = status;
      },error(err) {
        
      },complete() {
        
      },
    });

  }
  openHelpModal(): void {
    const modalRef = this.modalService.create({
      nzTitle: 'Support',
      nzContent: VjHelpNavBarComponent,
      nzFooter: [],
      
    });
  }
  
  
  






  getLoginStatus(){
    this.UserStatus =  this.authenticationService.loginDisplay;
  
  }

  login(){
    this.authenticationService.loginRedirect();
  }

  logout(){
    localStorage.clear();
    this.authenticationService.logout();
  }

}
